var map = {
	"./Exit/ExitControl": 7533,
	"./Info/InfoControl": 8233,
	"./Live/LiveControl": 4381,
	"./LockCategories/LockCategoriesControl": 9787,
	"./Menu/MenuControl": 3867,
	"./Move/MoveControl": 3207,
	"./MoveChannels/MoveChannelsControl": 703,
	"./MovieInfo/MovieInfoControl": 3407,
	"./Movies/MoviesControl": 6713,
	"./ParentalCode/ParentalCodeControl": 6625,
	"./Player/PlayerControl": 4947,
	"./Search/SearchControl": 2149,
	"./Settings/SettingsControl": 4039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3003;